import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const TitleWrapper = styled.div`
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.2px;
  line-height: 26px;

  ::first-letter {
    text-transform: uppercase;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: flex-end;

  .ant-select {
    min-width: 100px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
    align-items: baseline;
    gap: 16px;
  }
`;
